const migrationSelector = '[data-gf-cart-private-migration]';
const processedLineKeys = new Set();
let migrationRunning = false;

function privateProperties(properties) {
  const result = {};
  const entries = Array.isArray(properties) ? properties : Object.entries(properties);

  for (const [key, value] of entries) {
    if (key.startsWith('_')) result[key] = value;
  }
  for (const [key, value] of entries) {
    if (key.startsWith('_')) continue;
    const privateKey = `_${key}`;
    if (!(privateKey in result)) result[privateKey] = value;
  }

  return result;
}

function migrationDescriptors() {
  const byLineKey = new Map();

  for (const element of document.querySelectorAll(migrationSelector)) {
    const lineKey = element.dataset.lineKey;
    if (!lineKey || processedLineKeys.has(lineKey) || byLineKey.has(lineKey)) continue;

    byLineKey.set(lineKey, {
      lineKey,
      quantity: Number(element.dataset.lineQuantity) || 1,
    });
  }

  return [...byLineKey.values()];
}

function allowStandardCheckout() {
  for (const button of document.querySelectorAll('[data-gf-checkout-normalising]')) {
    if (button.hasAttribute('data-gf-checkout-blocked')) continue;
    button.disabled = false;
    button.removeAttribute('data-gf-checkout-normalising');
  }
  document.querySelectorAll('[data-gf-cart-preparing]').forEach((status) => status.remove());
}

function showMigrationError() {
  for (const status of document.querySelectorAll('[data-gf-cart-preparing]')) {
    status.textContent = 'Your saved design is safe, but checkout could not be prepared. Refresh and try again.';
    status.setAttribute('role', 'alert');
  }
}

async function migratePublicSourceProperties() {
  if (migrationRunning) return;
  const descriptors = migrationDescriptors();
  if (!descriptors.length) return;

  migrationRunning = true;
  try {
    const root = window.Shopify?.routes?.root || '/';
    const cartResponse = await fetch(`${root}cart.js`, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    });
    if (!cartResponse.ok) throw new Error(`Cart read returned ${cartResponse.status}`);
    const cart = await cartResponse.json();

    for (const descriptor of descriptors) {
      const item = cart.items?.find((cartItem) => cartItem.key === descriptor.lineKey);
      if (!item) throw new Error('The saved-design cart line could not be found.');
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: descriptor.lineKey,
          quantity: Number(item.quantity) || descriptor.quantity,
          properties: privateProperties(item.properties || {}),
        }),
      });
      if (!response.ok) throw new Error(`Cart update returned ${response.status}`);
      processedLineKeys.add(descriptor.lineKey);
    }

    if (window.location.pathname.replace(/\/+$/, '') === '/cart') {
      window.location.reload();
      return;
    }
    allowStandardCheckout();
  } catch (error) {
    console.warn('[GetFigure cart] Could not make saved-design properties private.', error);
    showMigrationError();
  } finally {
    migrationRunning = false;
  }
}

document.addEventListener('submit', (event) => {
  if (!(event.target instanceof HTMLFormElement) || !event.target.classList.contains('cart-form')) return;
  if (!document.querySelector('[data-gf-checkout-blocked], [data-gf-checkout-normalising]')) return;
  event.preventDefault();
});

const observer = new MutationObserver(() => migratePublicSourceProperties());
observer.observe(document.documentElement, { childList: true, subtree: true });
migratePublicSourceProperties();
